import React, { memo } from 'react'
import { Swiper as MUISwiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Mousewheel } from 'swiper/core'
import { Navigation, Pagination } from 'swiper'
import isFunction from 'lodash/isFunction'
import { Box } from '@mui/material'
import ResponsiveImage from '../ResponsiveImage'
import sx from './styles'

const Swiper = (props) => {
  const {
    items = [],
    renderItem = null,
    prefixIds = 'common-banner',
    containerStyles = {},
    hideNavigationOnEnd = false,
    mousewheel = false,
    ...other
  } = props

  if (mousewheel) SwiperCore.use([Mousewheel])

  return (
    <Box sx={[containerStyles, sx.hideNavOnEnd(hideNavigationOnEnd)]}>
      <MUISwiper
        navigation
        slidesPerView={1}
        preventClicksPropagation
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
        mousewheel
        {...other}
      >
        {items.map((item, index) => (
          <SwiperSlide key={`${prefixIds}-${index}-${item?.title || ''}`}>
            {
              isFunction(renderItem)
                ? renderItem(item, index)
                : (
                  <ResponsiveImage
                    image={item}
                    src={item.url}
                    title={item?.title}
                    key={item.title}
                  />
                )
            }
          </SwiperSlide>
        ))}
      </MUISwiper>
    </Box>
  )
}

export default memo(Swiper)
